<template>
  <layout>
    <page-header :header="$t('orders.create_payment_order')" />
    <div class="content">
      <resource-form
        v-if="currentDivision"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'orders'

export default {
  name: 'OrderCreate',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
